import { resizeObserver } from './utils/resize-observer';

const { on } = window.ivent;

// Set height announcement bar.
on(document, 'ready', () => {
	resizeObserver('#announcement-bar-root', 'height', (entry) => {
		document.body.style.setProperty(
			'--announcement-bar--height',
			`${entry.contentRect.height}px`,
		);
	});
});
